import { styled } from '@mui/joy';
import Card from '@mui/joy/Card';

export const BaseCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.isDarkMode
    ? theme.palette.neutral[200]
    : theme.palette.neutral[100],
}));
